import { render, staticRenderFns } from "./CampaignsFlowSidebar.vue?vue&type=template&id=e89e8e66&scoped=true&"
import script from "./CampaignsFlowSidebar.vue?vue&type=script&lang=js&"
export * from "./CampaignsFlowSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsFlowSidebar.vue?vue&type=style&index=0&id=e89e8e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89e8e66",
  null
  
)

export default component.exports